import UserService from "api/user/user";
import getCleanViewOrdersGroups from "v4/pages/admin/ViewOrders/contexts/utils/getCleanViewOrdersGroups";
import {CONTACT, PRODUCT, PROSPECT, QUOTE, TASK} from "v4/data/entities";
import {toCapitalize} from "v4/utils";

export default function getCleanViewOrders(allNavigationItems = []) {
    const viewOrdersFromLocalStorage = UserService.getViewOrders();
    if (!viewOrdersFromLocalStorage) return {};

    const viewOrders = Object.entries(viewOrdersFromLocalStorage).reduce((acc, [entity, viewOrder]) => {
        const {idViewOrderCustomer, form, search} = viewOrder;
        acc[entity] = {
            id: idViewOrderCustomer,
            ...(form && {form: getCleanViewOrdersGroups(entity, form)}),
            ...(search && {search: getCleanViewOrdersGroups(entity, search, true)}),
        };
        return acc;
    }, {});

    // Return sorted view orders by entity name and remove unhandled entities
    const sortedViewOrders = Object.keys(viewOrders).sort().reduce((acc, entityName) => {
        if ([PROSPECT, CONTACT, TASK, QUOTE, PRODUCT].includes(entityName.toLowerCase())) {
            acc[entityName] = viewOrders[entityName];
        }
        return acc;
    }, {});

    // Built-in tabs that must always have a view order if not in local storage
    const builtinTabs = [
        { id: 'business', searchType: 'prospect' },
        { id: 'individual', searchType: 'prospect' },
        { id: 'contact', searchType: 'contact' },
        { id: 'task', searchType: 'task' },
        { id: 'quote', searchType: 'quote' },
        { id: 'product', searchType: 'product' },
    ];

    const customTabs = allNavigationItems
        .filter(item => item.metadata?.tab_id && !item.metadata?.is_native)
        .map(item => ({
            id: item.metadata.tab_id,
            searchType: item.search_type || item.metadata?.search_type || 'prospect'
        }));

    const allTabs = [...builtinTabs, ...customTabs];

    const tabsWithoutViewOrder = allTabs.filter(tab => {
        if (!tab.id || !tab.searchType) return false;
        
        const entityName = toCapitalize(tab.searchType);
        if (!sortedViewOrders[entityName]) return true;

        const {form = {}, search = {}} = sortedViewOrders[entityName];
        const hasForm = form[tab.id] !== undefined;
        const hasSearch = search[tab.id] !== undefined;
        
        const needsSearch = !['business', 'individual'].includes(tab.id);

        // Filter tab if it's missing 'form' or if it needs 'search' and doesn't have it
        return !hasForm || (needsSearch && !hasSearch);
    });

    return createEmptyViewOrdersForTabs(sortedViewOrders, tabsWithoutViewOrder);
}

function createEmptyViewOrdersForTabs(viewOrders, tabsWithoutViewOrders) {
    return tabsWithoutViewOrders.reduce((acc, tab) => {
        const entityName = toCapitalize(tab.searchType);
        
        if (!acc[entityName]) {
            acc[entityName] = { form: {}, search: {} };
        }
        if (!acc[entityName].form) acc[entityName].form = {};
        if (!acc[entityName].search) acc[entityName].search = {};

        if (!acc[entityName].form[tab.id]) {
            acc[entityName].form[tab.id] = [];
        }
        
        const needsSearch = !['business', 'individual'].includes(tab.id);
        if (needsSearch && !acc[entityName].search[tab.id]) {
            acc[entityName].search[tab.id] = [];
        }

        return acc;
    }, viewOrders);
}
